//? Global
export const environment = import.meta.env.VITE_ENVIRONMENT;
export const disableLocalStorageEncryption = import.meta.env.VITE_DISABLED_LOCAL_STORAGE_ENCRYPTION === "true";
export const disablePostHog = import.meta.env.VITE_DISABLED_POSTHOG === "true";
export const devMode = environment === "LOCAL" || location.hostname === "localhost";

//? App
export const contentMaxWidth = 1400;
export const modalMaxWidthSmall = contentMaxWidth / 2;
export const defaultPageSize = 20;

//? Auth
export const authSignUpHint = "sign-up";
export const authLoginHint = "login";
export const passwordMinLength = 8;

//? Components
export const centerContentPageHolderDecorationWidth = 360;

//? Property Scraping
export const propertyScrapeMinImagesAmount = 4;
export const propertyScrapeTimeout = 60 * 1000;
